import { create } from 'zustand';

import { MyProfileResponse } from '../../../services/baseAuth';

type ProfileStore = MyProfileResponse & {
  set: (profile: MyProfileResponse) => void;
  reset: () => void;
};

const initialState = {
  status: '',
  id: 0,
  name: '',
  email: '',
  cover: null,
  roles: [],
  created: '',
  username: '',
  tags: [],
  tags_count: 0,
  is_verified: false,
  is_activated: false,
  verified_type: '',
  photo: 'https://cdn190.picsart.com/232804661007900.png',
  default_profile_pic: true,
  email_encoded: '',
  brand: {
    contacts: [],
    packages: [],
  },
  provider: '',
  firebase: {
    apple: [],
    android: [],
  },
  connections: [],
  has_password: true,
  verified_emails: [],
  username_changed: false,
  verified_categories: [],
  likes_count: 0,
  following_count: 0,
  followers_count: 0,
  teams: [],
  no_index: true,
  photos_count: 0,
  stickers_count: 0,
  subscription: {
    is_trial_used: false,
    granted: false,
  },
  has_user_followings: false,
  key: '',
  registered: true,
  email_verification: {
    popup_data: {
      show_popup: false,
    },
  },
  type: '',
  points: 0,
  saves_count: 0,
  remix_score: 0,
  top_fans_count: 0,
  locations_count: 0,
  has_top_fans: false,
  dashboard_visibility: false,
  interests: [],
  permissions: [],
  shop_subscriptions: [],
  selected_interests: {
    sticker: [],
    photo: [],
  },
  mature: false,
  show_report_popup: false,
  is_verified_type_new: false,
};

export const useProfileStore = create<ProfileStore>()((set, get) => {
  return {
    ...initialState,

    set: (profile: ProfileStore) => {
      set(profile);
    },

    reset: () => {
      set({
        ...initialState,
      });
    },
  };
});
